import { baseRestApi } from "api/rest/baseRestApi";
import { ApiResponsePaginatedCursor } from "api/rest/types/responses";
import paramsToTuples from "utils/paramsToTuples";

import { PaginatedQueryParams, SearchQueryParamsBase } from "../types/requests";
import { Smc3Carrier } from "./types";

type QueryParams = PaginatedQueryParams<
  SearchQueryParamsBase & {
    allowsContractPricing?: boolean;
    allowsDispatch?: boolean;
  }
>;

type QueryArgs = {
  queryParams: QueryParams;
};

type ResponseType = ApiResponsePaginatedCursor<Smc3Carrier[]>;

module.hot?.accept();

export const findManyCarriersSmc3 = baseRestApi.enhanceEndpoints({ addTagTypes: ["CARRIERS"] }).injectEndpoints({
  overrideExisting: module.hot?.status() === "apply",
  endpoints: (builder) => ({
    findManyCarriersSmc3: builder.query<ResponseType, QueryArgs>({
      query: ({ queryParams }) => ({
        method: "GET",
        url: `shipper/smc3/carriers`,
        params: paramsToTuples(queryParams),
      }),
      providesTags: ["CARRIERS"],
    }),
  }),
});

export const { useFindManyCarriersSmc3Query } = findManyCarriersSmc3;
export type FindManyCarriersSmc3ResponseType = ResponseType;
